import { ReactNode } from 'react';
import { Info } from 'lucide-react';

import { Button } from 'components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from 'components/ui/dialog';

type CsvImportInfoButtonProps = {
    title: string;
    children: ReactNode;
};

export const CsvImportInfoButton = ({ title, children }: CsvImportInfoButtonProps) => {
    return (
        <Dialog>
            <DialogTrigger asChild>
                <Button type="button" variant="ghost" size="icon-sm" aria-label="Aide import CSV">
                    <Info className="size-4" />
                </Button>
            </DialogTrigger>
            <DialogContent className="sm:max-w-lg">
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    <DialogDescription asChild>
                        <div className="flex flex-col gap-3 text-sm text-foreground">{children}</div>
                    </DialogDescription>
                </DialogHeader>
            </DialogContent>
        </Dialog>
    );
};
